import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import RazorInputField from "../inputField/RazorInputField";
import { colors } from "../variable";

export interface ModalProps {
  visible?: boolean;
  btnColor?: colors["value"];
  onBtnClick?: (e?: any) => void;
  children?: ReactNode;
  btnLabel?: string;
  className?: string;
  onClose?: () => void;
  outerClose?: boolean;
  loading?: boolean;
  disabled?: boolean;
  effect?: "fadeInUp" | "fadeInDown" | "fadeInLeft" | "fadeInRight";
  dontShowClose?: boolean;
  closeColor?: string;
  modalRootId?: string;
}

const RazorModal: React.FC<ModalProps> = ({
  visible,
  btnColor,
  onBtnClick,
  btnLabel,
  children,
  className,
  onClose,
  loading,
  disabled,
  effect,
  dontShowClose,
  closeColor,
  outerClose,
  modalRootId,
}) => {
  // Don't render anything if not visible and no portal
  if (!visible && !modalRootId) {
    return null;
  }

  const handleOuterClick = () => {
    if (outerClose && onClose) {
      onClose();
    }
  };

  const modalContent = (
    <div
      className={`modal-parent-wrap ${className}`}
      style={{
        display: visible ? "block" : "none",
      }}
    >
      <div onClick={handleOuterClick} className="modal__close-div-wrap" />
      <div
        className={`raven-modal-content-wrap raven-modal-content-wrap-${effect}`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking modal content
      >
        {!dontShowClose && (
          <div className="close-box">
            <figure onClick={onClose} className="img-box">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="img dull-bright-filter"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke={closeColor ? "black" : undefined}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </figure>
          </div>
        )}

        <div className="content">{children}</div>

        {btnLabel && (
          <div className="button-wrap">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onBtnClick && onBtnClick();
              }}
              className="form"
            >
              <RazorInputField
                type="submit"
                value={btnLabel}
                onSubmit={onBtnClick}
                loading={loading}
                color={btnColor}
                disabled={disabled}
              />
            </form>
          </div>
        )}
      </div>
    </div>
  );

  // If modalRootId is provided, use portal
  if (modalRootId) {
    const modalRoot = document.getElementById(modalRootId);
    if (modalRoot) {
      return ReactDOM.createPortal(modalContent, modalRoot);
    }
  }

  // Fallback to direct render
  return modalContent;
};

export default RazorModal;
